import type { BaseUserState } from '~/types/tShared';
import notificationAction from '@tempus/t-shared/ui/store/notification/actions';
import userAction from '@tempus/t-shared/ui/store/user/actions';
import { call, put, takeEvery, select } from 'redux-saga/effects';

import api from '~/store/api';

import {
  GET_CURRENT_USER,
  GET_USER_NOTIFICATION_PREFERENCES,
  UPDATE_USER_NOTIFICATION_PREFERENCE,
  UserNotificationPreferenceSection,
} from './types';
import { EnhancedUserState } from '.';

function* getCurrentUser() {
  try {
    const baseUser: BaseUserState & EnhancedUserState = yield call(api.users.getCurrentUser);
    const currentUser = yield select((state) => state.user);
    yield put(userAction.setUser({ ...currentUser.user, ...baseUser }));
  } catch (error) {
    if (error instanceof Error) {
      yield put(notificationAction.showErrorMessage(error.message));
    }
  }
}

function* getUserNotificationPreferences() {
  try {
    const currentUser = yield select((state) => state.user);
    const selectedUserSite = yield select(({ site }) => site.selectedUserSite);

    const userNotificationPreferences: UserNotificationPreferenceSection[] = yield call(
      api.users.getNotificationPreferences,
      selectedUserSite?.id,
    );

    const groupedNotificationPreferences = [
      {
        title: 'TIME trials',
        notifications: userNotificationPreferences,
      },
    ];

    yield put(
      userAction.setUser({
        ...currentUser.user,
        notificationPreferences: groupedNotificationPreferences,
      }),
    );
  } catch (error) {
    if (error instanceof Error) {
      yield put(notificationAction.showErrorMessage(error.message));
    }
  }
}

function* updateUserNotificationPreference(action) {
  try {
    const { notificationPreference } = action;

    yield call(api.users.updateNotificationPreference, notificationPreference);
    yield put(notificationAction.showSuccessMessage('Notification preference updated successfully.'));
    yield call(getUserNotificationPreferences);
  } catch (error) {
    if (error instanceof Error) {
      yield put(notificationAction.showErrorMessage(error.message));
    }
  }
}

export default [
  takeEvery(GET_CURRENT_USER, getCurrentUser),
  takeEvery(GET_USER_NOTIFICATION_PREFERENCES, getUserNotificationPreferences),
  takeEvery(UPDATE_USER_NOTIFICATION_PREFERENCE, updateUserNotificationPreference),
];
